import { LoginField } from "./login-fields";
export class LoginFieldsSerializer {

  fromJson(json: any): LoginField {
    const lf = new LoginField();
    lf.success = json.success;
    lf.data = this.toJson(json.data);
    return lf;
  }

  toJson(lf: LoginField): any {
    if (typeof lf === 'object') {
      return lf;
    }
  }
}
